// extracted by mini-css-extract-plugin
export default {"deleteBtn":"styles_deleteBtn__Vtk2r","deleteBtnContent":"styles_deleteBtnContent__gTih5"};